import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-item-allowances',
    name: 'pay-item-allowance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-item-allowance')
  }
]
